var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.clientDetail)?_c('div',[_c('client-editable-detail',{attrs:{"detail":_vm.clientDetail},on:{"fetch-client-required":_vm.handleFetchClientRequired}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }